import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-question-damage-image-right',
    templateUrl: './question-damage-image-right.component.html',
    styleUrls: ['./question-damage-image-right.component.scss'],
    standalone: false
})
export class QuestionDamageImageRightComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
